@if (cueHistory.length > 0) {
	<section class="cue-history">
		<div class="cue-section-title">
			<span class="cue-step-label">4. Historial</span>
			<h4>Últimos envíos</h4>
			<p class="muted">Primero se muestra el resumen útil. Los códigos y JSON quedan en detalles técnicos.</p>
		</div>

		@for (item of cueHistory; track item.id) {
			<article class="cue-history__item">
				<div class="cue-history__header">
					<div>
						<strong>{{ item.fecha | date: 'dd/MM/yyyy' }}</strong>
						<span>{{ statusLabel(item) }}</span>
					</div>

					<p-tag [value]="statusLabel(item)" [severity]="statusSeverity(item)" [rounded]="true"></p-tag>
				</div>

				<div class="cue-history__stats" aria-label="Resumen del envío">
					<span>✓ {{ acceptedCount(item) }} aceptadas</span>
					<span>⚠ {{ rejectedCount(item) }} con problemas</span>
					<span>⏳ {{ pendingCount(item) }} por revisar</span>
				</div>

				@if (shouldShowProblemBlock(item)) {
					<details class="cue-history__review" [open]="reviewFilter === 'problems'">
						<summary>Ver qué hay que corregir</summary>

						<div class="cue-history__issue-list">
							@for (issue of actionableIssues(item); track issue.id) {
								<article class="cue-history__issue">
									<strong>{{ issue.title }}</strong>
									<p><strong>Qué pasa:</strong> {{ issue.message }}</p>
									<p><strong>Dónde corregirlo:</strong> {{ issue.location }}</p>
									<p><strong>Qué hacer:</strong> {{ issue.action }}</p>

									@if (issue.technicalDetail) {
										<details class="cue-inline-technical-details">
											<summary>Ver detalle técnico</summary>
											<pre>{{ issue.technicalDetail }}</pre>
										</details>
									}
								</article>
							}
						</div>
					</details>
				}

				@if (shouldShowAcceptedBlock(item)) {
					<details class="cue-history__review" [open]="reviewFilter === 'accepted'">
						<summary>Ver actividades aceptadas</summary>

						<div class="cue-history__accepted-list">
							@for (activity of acceptedReviews(item); track activity.id) {
								<div class="cue-history__accepted-item">
									<i class="pi pi-check-circle" aria-hidden="true"></i>
									<span>{{ activity.label }}</span>
									<p-tag [value]="activity.statusLabel" [severity]="activity.severity" [rounded]="true"></p-tag>
								</div>
							}
						</div>
					</details>
				}

				<app-cue-technical-details [details]="technicalDetails(item)"></app-cue-technical-details>
			</article>
		}
	</section>
}
